import { cn } from "../lib/utils";
import React from "react";

export function GridBackground({
  className,
  gridColor = "#444444",
  mask = true,
  maskClassName,
  style = {}
}) {
  return (
    <>
      <div
        className={cn(
          "absolute inset-0 z-0 pointer-events-none transition-colors duration-500",
          className
        )}
        style={{
          backgroundSize: "40px 40px",
          backgroundPosition: "center top",
          backgroundAttachment: "fixed",
          backgroundImage: `linear-gradient(to right, ${gridColor} 1px, transparent 1px), linear-gradient(to bottom, ${gridColor} 1px, transparent 1px)`,
          ...style
        }}
      />
      {mask && (
        <div
          className={cn(
            "pointer-events-none absolute inset-0 z-10 flex items-center justify-center bg-black [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)]",
            maskClassName
          )}
        />
      )}
    </>
  );
}
